let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5D8Fc")).then(() => parcelRequire('l54tv'));